import { Heading } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { getVehicleConditionList } from "../../data/vehicle";
import { TilesSelectGroup } from "../generic/TileSelectGroup";
import { BrandType } from "@bus/models";

export const VehicleCondition = () => {
    const { t } = useTranslation(["question1page"]);
    const brand = process.env.REACT_APP_WEBSITE_BRAND;

    const getTitle = () => {
        switch (brand) {
            case BrandType.VW:
                return t("question1page:vehicle-condition.titleVW");
            case BrandType.VWN:
                return t("question1page:vehicle-condition.titleVWN");
            case BrandType.AUDI:
                return t("question1page:vehicle-condition.titleAudi");
            default:
                return t("question1page:vehicle-condition.title");
        }
    }

    return (
        <>
            <Heading level={2} className={'u-font-size-fs2'}>{getTitle()}</Heading>

            <TilesSelectGroup
                fieldName="conditions"
                list={getVehicleConditionList(t)}
                className="u-1/2 u-1/2@l u-1/1@s u-text-left VehicleConditions"
                required
            />
            
        </>
    );
};
